import { useNuxtApp } from 'nuxt/app';
import { formatPriceToStr } from '~~/common/utils/price';

export function useFormatPriceToStr () {
  const { $i18n } = useNuxtApp();
  return function (
    arg: Omit<Parameters<typeof formatPriceToStr>[0], 'locale'>,
  ) {
    return formatPriceToStr({
      ...arg,
      locale: $i18n.locale.value,
    });
  };
}
